<template>
  <div class="DiscussionErrors">
    <div v-if="hasErrors">
      <v-alert
        v-if="errorCount <= showDetailFor"
        ref="errorAlert"
        tabindex="0"
        color="error"
        dark
      >
        <div v-for="(error, index) in errors" :key="index">
          {{ error.resolutionMessage }}
        </div>
      </v-alert>
      <v-alert v-else ref="errorAlert" tabindex="0" color="error" dark>
        <div>
          There are {{ errorCount }} errors on this form. Please rectify them
          before continuing.
        </div>
      </v-alert>
    </div>
  </div>
</template>

<script>
export default {
  name: "DiscussionErrors",
  props: {
    errors: { type: Array, default: () => [] },
    showDetailFor: { type: Number, default: 3 },
  },
  computed: {
    errorCount() {
      return this.errors.length;
    },
    hasErrors() {
      return this.errors.length > 0;
    },
  },
  watch: {
    hasErrors(hasErrors) {
      if (hasErrors) {
        this.$nextTick(() => this.$refs.errorAlert.$el.focus());
      }
    },
  },
};
</script>

<style>
.DiscussionErrors .v-alert {
  margin-bottom: 0;
}
</style>
